export const memoriesData = {
  photoGallery: [
    {
      id: 1,
      image: "/memories/eram-promo.jpeg",
      caption: "ERAM Digital - Business Head IT & ITES Announcement",
      category: "Career"
    },
    {
      id: 2,
      image: "/memories/doctorate.jpeg",
      caption: "Doctor of Business Administration - AI & Cybersecurity",
      category: "Education"
    },
    {
      id: 3,
      image: "/memories/rollball-men.jpg",
      caption: "Proud to host the Indian National Rollball men's team who won the 7th World Cup against Kenya",
      category: "Sports"
    },
    {
      id: 4,
      image: "/memories/rollball-ladies.jpg",
      caption: "Proud to host the Indian National Rollball women's team who won the 7th World Cup against Kenya",
      category: "Sports"
    },
    {
      id: 5,
      image: "/memories/rollball-guest.jpg",
      caption: "Chief Guest at Roll Ball Championship",
      category: "Sports"
    },
    {
      id: 6,
      image: "/memories/mentor.jpg",
      caption: "Mentoring & Leadership",
      category: "Leadership"
    },
    {
      id: 7,
      type: "video",
      videoId: "wmCMdUHynKA",
      thumbnail: "https://img.youtube.com/vi/wmCMdUHynKA/maxresdefault.jpg",
      caption: "CXO 2.0 Conference - Business Leadership Excellence Award",
      category: "Awards"
    },
    {
      id: 13,
      type: "video",
      videoSrc: "/memories/cxo-influence.mp4",
      thumbnail: "/memories/cxo-influence-poster.jpg",
      caption: "Featured on CXO Influence — AI Amplifies Human Potential",
      category: "Features"
    },
    {
      id: 14,
      image: "/memories/indian-achievers-524.jpg",
      caption: "Featured on the cover of The Indian Achievers — Edition 524, Business Talkz Magazine",
      category: "Features",
      link: "https://www.businesstalkz.com/2026/05/the-indian-achievers-edition-524.html",
      linkLabel: "Read on Business Talkz"
    },
    {
      id: 15,
      image: "/memories/indian-achievers-524.jpg",
      caption: "“Grateful to be recognized in the 524th edition of The Indian Achievers. At ITHR Technologies, we remain committed to driving excellence and innovation in the tech landscape.” — shared on LinkedIn",
      category: "Features",
      link: "https://www.linkedin.com/posts/srijit-nair-ithr_ithrtechnologies-techinnovation-indianachievers-share-7464671538814857216-4pc8/",
      linkLabel: "View on LinkedIn"
    },
    {
      id: 16,
      image: "/memories/impactpreneur-cover.jpg",
      caption: "Cover Feature — Impactpreneur Magazine, Summer 2025. ‘Srijit Nair: CEO ITHR Technologies and digital growth expert — setting a new standard for integrated enterprise consulting where human capital strategy is a foundational driver of digital growth.’",
      category: "Features",
      link: "https://www.linkedin.com/posts/impactpreneur-businessmagazine-it-share-7358500875398471682-QeXL/",
      linkLabel: "View on LinkedIn"
    },
    {
      id: 17,
      image: "/memories/impactpreneur-interview.jpg",
      caption: "Featured Interview — Impactpreneur Magazine. ‘ITHR Technologies CEO Srijit Nair on purposeful innovation and leadership — humanising technology and simplifying transformation, so people, platforms, and purpose align in a single scalable continuum.’",
      category: "Features",
      link: "https://www.linkedin.com/posts/impactpreneur-interview-spotlight-share-7348651216765124608-mR3y/",
      linkLabel: "View on LinkedIn"
    },
    {
      id: 18,
      image: "/memories/impactpreneur-leadership-panel.jpg",
      caption: "Panelist at the Impact Leadership Forum — sharing purpose-driven leadership stories with Hala Jaber, Debra Joy, Lluís Mas, Marina Stroganova and Arpana Sharma, hosted by Dia Thombre.",
      category: "Speaking",
      link: "https://www.linkedin.com/posts/impactpreneur-leadershipforum-businessowners-share-7353333797343444992-30q9/",
      linkLabel: "View on LinkedIn"
    },
    {
      id: 19,
      image: "/memories/impactpreneur-forum-group.jpg",
      caption: "Impact Leadership Forum — group photo with founders, CEOs and industry leaders gathered to discuss business integrity, hiring, fostering young talent and growing ventures on passion and purpose.",
      category: "Events",
      link: "https://www.linkedin.com/posts/impactpreneur-forum-businessmagazine-share-7352649747221876736-Q8Od/",
      linkLabel: "View on LinkedIn"
    },
    {
      id: 20,
      image: "/memories/prime-today-cover.jpg",
      caption: "Cover Feature — The Prime Today Magazine. Recognised as one of the Most Influential Business Leaders to Watch in 2026. Cover story: ‘The Talent Synchronizer — Srijit Nair's Integrated Blueprint for Technical Depth, Human Capital Strategy, and Continuous Enterprise Transformation.’",
      category: "Features",
      link: "https://theprimetoday.com/one-of-the-most-influential-business-leaders-to-watch-in-2026/",
      linkLabel: "Read on The Prime Today"
    },
    {
      id: 21,
      image: "/memories/imc-share.jpg",
      caption: "Awarded IMC Individual Member status — a verified digital credential issued by the International Mentoring Center recognising commitment to ethical, evidence-based mentoring practice. Credential ID: cd5936dc20357.",
      category: "Memberships",
      link: "https://www.linkedin.com/posts/srijit-nair-ithr_imc-individual-member-this-digital-credential-share-7475843230769704960-xJ69/",
      linkLabel: "View on LinkedIn"
    },
    {
      id: 8,
      image: "/memories/kerala-summit.jpeg",
      caption: "Grateful to F9 Technologies - Kerala Cyber Suraksha Summit 2025",
      category: "Events"
    },
    {
      id: 9,
      image: "/memories/gec-award.jpeg",
      caption: "GEC Media recognizes the value - Top Vendor Award",
      category: "Awards"
    },
    {
      id: 10,
      image: "/memories/gec-retro.jpeg",
      caption: "GEC Awards 2024 - Retro Night Celebration",
      category: "Awards"
    },
    {
      id: 11,
      image: "/memories/cxo-speaking.jpeg",
      caption: "CXO 2.0 Conference - Keynote Speaker",
      category: "Speaking"
    },
    {
      id: 12,
      image: "/memories/cxo-group.jpeg",
      caption: "CXO 2.0 Conference - Award Recipients Group Photo",
      category: "Awards"
    }
  ],

  milestones: [
    {
      id: 0,
      year: "2026",
      title: "Business Head IT & ITES at ERAM Digital",
      description: "Joined ERAM Digital, a subsidiary of ERAM Holdings, as Business Head IT & ITES (Fractional) in Al Khobar, Saudi Arabia. Leading strategic planning, business development, and operational management for the IT services division.",
      icon: "building"
    },
    {
      id: 1,
      year: "2024",
      title: "Founded ITHR Technologies Consulting LLC",
      description: "Launched my own consulting firm focused on innovative human capital strategies and digital transformation in the IT industry.",
      icon: "rocket"
    },
    {
      id: 2,
      year: "2024",
      title: "Co-Founded ITHR 360\u00b0 Consulting",
      description: "Partnered with industry leaders to create a comprehensive HR consulting practice serving the Middle East region.",
      icon: "handshake"
    },
    {
      id: 3,
      year: "2019",
      title: "Director of Operations at Logic Point",
      description: "Took on operational leadership at one of UAE's leading IT consulting firms, driving efficiency and client satisfaction.",
      icon: "briefcase"
    },
    {
      id: 4,
      year: "2011",
      title: "Executive Director at Skillsearch Resources",
      description: "Led the company through significant growth, expanding operations and building a strong team culture.",
      icon: "trending-up"
    },
    {
      id: 5,
      year: "2004",
      title: "Executive Director at Candid Consultants",
      description: "Started my leadership journey, learning the fundamentals of business management and client relations.",
      icon: "star"
    },
    {
      id: 6,
      year: "2002",
      title: "Career Beginning at Wipro Spectramind",
      description: "Joined one of India's premier IT services companies, laying the foundation for my career in technology and HR.",
      icon: "play"
    }
  ],

  events: [
    {
      id: 8,
      title: "IMC Individual Member — International Mentoring Center",
      date: "June 2026",
      location: "International Mentoring Center",
      description: "Awarded Individual Member status by the International Mentoring Center — a verified digital credential recognising commitment to ethical, evidence-based mentoring practice. Credential ID: cd5936dc20357.",
      image: "/memories/imc-share.jpg",
      type: "Membership",
      link: "https://www.linkedin.com/posts/srijit-nair-ithr_imc-individual-member-this-digital-credential-share-7475843230769704960-xJ69/"
    },
    {
      id: 7,
      title: "Cover Story — The Prime Today, ‘Most Influential Business Leaders to Watch in 2026’",
      date: "June 2026",
      location: "The Prime Today Magazine",
      description: "Featured on the cover of The Prime Today as one of the Most Influential Business Leaders to Watch in 2026. Cover story: ‘The Talent Synchronizer — Srijit Nair's Integrated Blueprint for Technical Depth, Human Capital Strategy, and Continuous Enterprise Transformation.’",
      image: "/memories/prime-today-cover.jpg",
      type: "Feature",
      link: "https://theprimetoday.com/one-of-the-most-influential-business-leaders-to-watch-in-2026/"
    },
    {
      id: 6,
      title: "Featured Cover — The Indian Achievers, Edition 524",
      date: "May 25, 2026",
      location: "Business Talkz Magazine",
      description: "Featured on the cover of The Indian Achievers — Edition 524 by Business Talkz, recognising contributions to people-centred digital transformation, leadership, and the bridge between IT and human capital.",
      image: "/memories/indian-achievers-524.jpg",
      type: "Feature",
      link: "https://www.businesstalkz.com/2026/05/the-indian-achievers-edition-524.html"
    },
    {
      id: 1,
      title: "Business Leadership Excellence Award - CXO 2.0 Conference",
      date: "December 8-10, 2025",
      location: "InterContinental DFC, Dubai",
      description: "Received the prestigious Business Leadership Excellence Award recognizing achievements in driving people-centered digital transformation and enterprise innovation.",
      image: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=800&h=400&fit=crop",
      type: "Award"
    },
    {
      id: 2,
      title: "Business Head IT & ITES - ERAM Digital",
      date: "February 2026",
      location: "Al Khobar, Saudi Arabia",
      description: "Joined ERAM Digital, a subsidiary of ERAM Holdings, as Business Head IT & ITES (Fractional). Leading strategic planning, business development, team building, and operational management.",
      image: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=800&h=400&fit=crop",
      type: "Career"
    },
    {
      id: 3,
      title: "CIO Festive Fusion 2025 - Onam Celebration",
      date: "September 2025",
      location: "Dubai, UAE",
      description: "Hosted and participated in CIO Festive Fusion 2025, bringing together IT leaders and CIOs from across the UAE to celebrate Onam.",
      image: "https://images.unsplash.com/photo-1511578314322-379afb476865?w=800&h=400&fit=crop",
      type: "Networking"
    },
    {
      id: 4,
      title: "ITHR Technologies Consulting LLC Launch",
      date: "August 2024",
      location: "Dubai, UAE",
      description: "Official launch of ITHR Technologies Consulting LLC, a consulting firm specializing in bridging IT, HR, and organizational transformation.",
      image: "https://images.unsplash.com/photo-1511578314322-379afb476865?w=800&h=400&fit=crop",
      type: "Launch"
    },
    {
      id: 5,
      title: "ITHR 360\u00b0 Consulting Co-Founding",
      date: "March 2024",
      location: "Dubai, UAE",
      description: "Co-founded ITHR 360\u00b0 Consulting as Strategic Advisor and COO, partnering with industry leaders to create a comprehensive HR consulting practice.",
      image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&h=400&fit=crop",
      type: "Launch"
    }
  ],

  stories: [
    {
      id: 1,
      title: "Building ITHR: A Vision for People-Centered Technology",
      type: "story",
      content: "Founded on the principle that sustainable transformation cannot exist without empowered people, ITHR Technologies Consulting operates at the critical nexus of IT, HR, and organizational change. Our mission is clear: Build systems that serve people\u2014so people can drive transformation. This journey from concept to reality has been the most rewarding chapter of my career.",
      image: "/pp2-story.jpg",
      date: "Reflection"
    },
    {
      id: 2,
      title: "From India to Dubai: A Cross-Cultural Leadership Journey",
      type: "story",
      content: "Working across India and the UAE has given me a unique perspective on cross-cultural leadership. Starting at Wipro Spectramind in Mumbai, through executive roles at Skillsearch Resources and Candid Consultants, to now leading ITHR in Dubai\u2014each step has been a lesson in resilience, innovation, and the power of human connection.",
      image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&h=400&fit=crop",
      date: "Experience"
    },
    {
      id: 3,
      title: "Leadership Philosophy: Building People, Not Just Businesses",
      type: "story",
      content: "I believe in bottom-up innovation. The best ideas come from those closest to the problem. This philosophy has shaped ITHR's culture where every voice is valued, silos are dismantled, and accountability is shared.",
      image: "https://images.unsplash.com/photo-1521791136064-7986c2920216?w=800&h=400&fit=crop",
      date: "Philosophy"
    },
    {
      id: 4,
      title: "Expanding to Saudi Arabia: ERAM Digital Journey",
      type: "story",
      content: "Joining ERAM Digital as Business Head IT & ITES marks an exciting new chapter. Leading strategic planning, business development, and building teams in Al Khobar represents the culmination of years of experience across India and the UAE.",
      image: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=800&h=400&fit=crop",
      date: "New Chapter"
    }
  ]
};
